// JsFromRoutes CacheKey c7521a8d5d35a4eaeba87050efb2b66a
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  createAdministratorComplete: /* #__PURE__ */ definePathHelper('post', '/employers/settings/create_administrator'),
  destroyAdministrator: /* #__PURE__ */ definePathHelper('delete', '/employers/settings/destroy_administrator'),
  disconnectPayroll: /* #__PURE__ */ definePathHelper('post', '/employers/settings/disconnect_payroll'),
  payrollRedirect: /* #__PURE__ */ definePathHelper('get', '/employers/settings/payroll_redirect'),
  payrollComplete: /* #__PURE__ */ definePathHelper('get', '/employers/settings/payroll_complete'),
  show: /* #__PURE__ */ definePathHelper('get', '/employers/settings'),
  update: /* #__PURE__ */ definePathHelper('patch', '/employers/settings'),
}
